import { Loading, PermissionDenied } from '@/components';
import type { FC, PropsWithChildren } from 'react';

import { useGlobalTagPermission } from '../_hooks/permission';
import type { ResourceGuardProps } from '../_types/authentication';

export const GlobalTagResourceGuard: FC<
  PropsWithChildren<ResourceGuardProps>
> = ({ onlyEdit, showDenied, children }) => {
  const permission = useGlobalTagPermission(onlyEdit);

  if (permission.isPending) {
    return <Loading />;
  }

  return permission.data ? (
    <>{children}</>
  ) : showDenied ? (
    <PermissionDenied />
  ) : null;
};
